import InstanceTypeConfig from "rwb/pages/project/types/enums/instanceTypeConfig";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

const useInstanceTypes = () => {
  return useFetcher<InstanceTypeConfig[]>(`${VITE_RWB_API}/resources/instance-types`, {
    keepPreviousData: true,
  });
};

export default useInstanceTypes;
